var $6382c2117e9fd1b6$exports = {};
$6382c2117e9fd1b6$exports = {
    "(optional)": `(opcijsko)`,
    "(required)": `(obvezno)`
};


export {$6382c2117e9fd1b6$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
